export type ColunaStatus = "documento" | "cadastro";

// Traduz o status vindo do backend (Status.getDescricao) para o rotulo e a classe
// visual do chip, conforme a coluna. Documentos (autorizacao/adesao) usam
// Enviar/Aprovado/Em analise/Recusado; cadastros (EC/taxas) usam Cadastrar/Cadastrado.
export const statusChip = (descricao: string | null | undefined, tipo: ColunaStatus): { label: string; classe: string } => {
  const acao = tipo === "cadastro" ? "Cadastrar" : "Enviar";
  const concluido = tipo === "cadastro" ? "Cadastrado" : "Aprovado";
  switch (descricao) {
    case "aprovado":
      return { label: concluido, classe: "aprovado" };
    case "aguardando":
      // Em cadastros (EC/taxas) aguardando significa pre-requisito pendente, nao analise
      return tipo === "cadastro" ? { label: acao, classe: "aguardando" } : { label: "Em análise", classe: "emAnalise" };
    case "cadastrado":
      return { label: "Em análise", classe: "emAnalise" };
    case "rejeitado":
    case "naoAutorizado":
      return { label: "Recusado", classe: "rejeitado" };
    case "pendente":
    default:
      return { label: acao, classe: "download" };
  }
};
